export default {"src":"/_next/static/media/KRAKEN.a671f0a0.svg","height":100,"width":650,"blurWidth":0,"blurHeight":0};